import { Typography } from "@mui/material";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { ReactNode } from "react";
import cardImg1 from "../assets/Images/image11.png";
import cardImg2 from "../assets/Images/image2.png";
import cardImg3 from "../assets/Images/image3.png";
import logo from "../assets/Images/Logo.png";
import logo2 from "../assets/Images/logo2.png";
import LogoCard from "../components/LogoCard";
import "../styles/sign.css";
import theme from "../theme";
import { Outlet } from "react-router-dom";
const Item = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  backgroundColor: "#2977CC",
  borderRadius: "0",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
  [theme.breakpoints.down("md")]: {
    height: "fit-content",
  },
  [theme.breakpoints.down("sm")]: {
    height: "fit-content",
    padding: "25px",
  },
}));
const Item1 = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  backgroundColor: "#F4F8FC",
  borderRadius: "0",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
  [theme.breakpoints.down("md")]: {
    height: "fit-content",
    padding: "25px",
  },
  [theme.breakpoints.down("sm")]: {
    height: "calc(100vh - 138px)", //"calc(100vh - 138px)"
    padding: "25px",
    overflowY: "auto",
  },
}));

interface LayoutProps {
  children?: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          height: "100%",
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{
            flexDirection: { sm: "column", md: "row", xs: "column" },
            display: "flex",
            flexWrap: "wrap",
            gap: "0px", // Optional, if overriding the default gap
          }}
        >
          <Grid size={{ xs: 12, md: 4 }}>
            <Item>
              <div className="logo-container">
                <div className="logo-container-img">
                  <div className="img-container">
                    <img
                      src={logo}
                      alt=""
                      style={{
                        width: "200px",
                        height: "75px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <Typography
                    className="logo-title-login"
                    variant="h1"
                    sx={{ marginBottom: "10px" }}
                  >
                 Welcome to TheITIN 
                    <br />Dashboard
                  </Typography>
                  <Typography className="logo-title1-login" variant="h3">
                 Log-In to Manage your ITIN Application,  <br />Business Formation, Compliance and All..
               
                  </Typography>
                </div>
                <div className="logo-container2">
                  <div>
                    <img src={logo2} alt="Logo" />
                  </div>
                  <LogoCard
                    id={"Helping"}
                    imgSrc={cardImg1}
                    description={" Lalaka P."}
                    SubDescription={
                      "They’re responsible and professional."
                    }
                    style={{ top: 80, left: 50 }}
                  />
                  <LogoCard
                    id={"Tailored"}
                    imgSrc={cardImg2}
                    description={" Rasim Nomer"}
                    SubDescription={" Super Smooth Experience!"}
                    style={{ top: 186, left: 97 }}
                  />
                  <LogoCard
                    id={"Business"}
                    imgSrc={cardImg3}
                    description={"Alper Nabil"}
                    SubDescription={"From start to end, fully friendly attitude."}
                    style={{ top: 300, left: 139 }}
                  />
                </div>
              </div>
            </Item>
          </Grid>
          <Grid size={{ xs: 12, md: 8 }}>
            <Item1>
              <Outlet />
            </Item1>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Layout;
